import { GlobalOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";

export type SiderTheme = "light" | "dark";

export const SelectLang: React.FC = () => {
  const items = [
    { key: "zh-CN", label: "中文" },
    { key: "en-US", label: "English" },
  ];
  const onClick = ({ key }: { key: string }) => {
    try {
      localStorage.setItem("umi_locale", key);
    } catch {}
    window.location.reload();
  };
  return (
    <Dropdown menu={{ items, onClick }}>
      <span style={{ padding: 4, cursor: "pointer" }}>
        <GlobalOutlined />
      </span>
    </Dropdown>
  );
};

export const Question: React.FC = () => {
  return (
    <a
      href="https://pro.ant.design/docs/getting-started"
      target="_blank"
      rel="noreferrer"
      style={{
        display: "inline-flex",
        padding: "4px",
        fontSize: "18px",
        color: "inherit",
      }}
    >
      <QuestionCircleOutlined />
    </a>
  );
};
